import React, { useState, useEffect, useRef } from "react";
import { SwitchTransition, CSSTransition } from "react-transition-group"; 

const brandStyles = {
  linkHover: "#68A637",
  deepBlue: "#394C92",
};


const aboutFeatures = [
   {
    src: process.env.PUBLIC_URL + "/images/Home/AboutOrgavitaz/AboutOrgavitaz.png",
    name: "Description",
    description:
      "",
    points: [
     "Product Description: Plant-based Vitamins & Minerals Complexes in 'as it exists' form scientifically defined to measure and manage RDA.",
     "Representing Forms: plant-based vitamers, broad-spectrum, bound to glycosides, aminos, fatty acids, phosphates, nucleotides and other forms of organic acids, precursor secondary metabolites and minerals.",
     "Functional Focus: BIO-OCTAVE - Bio-available-Organic-Cellular-Targeted-Active Vitamer Entities relatively less stable than synthetic or natural isolates.",
     "Mode of Action: Principle & Coenzyme Forms - reduced dependency on liver for biotransformation - primarily driven by GI or passive diffusion.",
   ],
  },
  {
    src: process.env.PUBLIC_URL + "/images/Home/AboutOrgavitaz/Science_Behind.jpg",
    name: "Broadspectrum Vitamers",
    description:
      "Whole-foods ‘as-it-exisits’ forms are Bio-vitamers complex that comes with its core co-nutrients. Carrier food factor is important to recognize a whole-food vitamer complex; sugars, proteins, fatty acids, enzymes and other nutrient activation factors are always linked with whole-food vitamins as a result the body absorbs it as a nutrient.",
    points: [
      "Vitamins in whole-food forms are colloidal, in the form of enzymes, co-enzymes, peptides, natural metabolites, activators and minerals complexes. So whole-food vitamins are ‘compound complexes' that are naturally existing in food and vitamin or mineral is part of the complex.",
      "Thousands of phytoconstituents are present in the whole-food complexes that are synergistic to vitamin/mineral activity and their biological activity is because of their synergistic effect.",
      "Whole-food forms does not represent a single form of vitamin/mineral, so when standardized as complexes, it may not offer multivitamins in higher percentages like synthetics or natural isolates.Whole-food complexes provide balanced carbs, proteins, and fats.",
    ],
  },
  {
    src: process.env.PUBLIC_URL + "/images/Home/AboutOrgavitaz/QualityByDesign.png",
    name: "Quality-By-Design",
    description:
      "Orgavitaz is the result of a carefully developed and integrated supply chain end-to-end invested and built for more than 15 years before commercialization.Orgavitaz is a result of 95% Regenerative Agriculture Technology, Agroecological Modeling, Sustainability & 5% Processing Technology Innovation",
    points: [
       "Process Quality Assurance ensures reduced Quality Control of Finished Goods.",
      "Third-party systems validate of agriculture., manufacturing and handling for stewardship.",
      "Separation of Primary Processing and High-value added processing to ensure defense.",
      "Critical Quantification controls that qualifies agriculture supplies for consistent actives.",
      "Intelligence and IOT based integration of quality data.",
      "Supply chain is captive for facilitating QBD control.",
      

    ],
  },
  {
    src: process.env.PUBLIC_URL + "/images/Home/AboutOrgavitaz/SpecializedAgriculture.png",
    name: "Specialized Agriculture",
    description: (
      <>
        Standardizing Plant-based Nutrition is not possible without Agriculture Technology. Commercial Agriculture production will not suit 
        <strong style={{ fontWeight: 'bold' }}> standardizing plant-based ingredients.</strong>
      </>
    ),
    points: [
      "26 Tropical Plant Species standardized as Champions, Balancers and Green Solvents",
      "Pure line Selection (No Hybrids and No GMO), Diversity Conserved and Propagation Standardized.",
      "Selection based on Critical Quantification Limits of actives from Fresh conducive for standardization with Proprietary cultural Practices.",
      "No genetic intervention or epigenetic sensitization",
      "Conservation based Regional Agroecological Modelling.",
      "DNA fingerprinted for testing genetic contamination",
      "Selection maintenance for purity tagged and traced for harvest conformity.",
    ],
  },
  {
    src: process.env.PUBLIC_URL + "/images/Home/AboutOrgavitaz/WholeFoodCocentrates-1.png",
    name: "Minimal Intervention",
    description:
      "Orgavitaz ingredients are vitamin-rich or and mineral-rich food complexes manufactured with no intervention of chemicals, excipients or carriers in any form. It is scientifically evident that naturally existing forms have high organic affinity and biological integrity, when they interact with the human body, unlike synthetics or isolates from naturals. Orgavitaz brings vitamins and minerals in plants as they exist through minimal-processing interventions and naturally existing bio-enhancers like plant-based solvents, enzymes and beneficial microbes as means to achieve desirable standardized forms.",
      
    points: [
      "So Orgavitaz’s whole-food forms does not represent a single form of vitamin/mineral and it cannot offer higher concentrations, but definitely with higher equivalence of bio-availability. ",
      "Orgavitaz standardized forms are carefully processed, just to offer right naturally possible concentrations without compromising the food and co-nutrient value. Thousands of phytoconstituents are present in the whole-food complexes that are synergistic to vitamin/mineral activity and their biological activity is because of their synergistic effect. ",
    ],
  },
  {
    src: process.env.PUBLIC_URL + "/images/Home/AboutOrgavitaz/CompliantManufacturing.png",
    name: "Compliant Manufacturing",
    description:
      "",
    points: [
      "Indian FSSAI Licensed and is assessed equivalent of EFSA and GRAS. No novel ingredients are used.",
      "Organic under Indian NPOP, EU & USDA certified by CUC India",
      "Test method validated by Third party Laboratory",
      "Non-GMO validated by CONSERV India",
      "Voluntary Certification Scheme (VCSMPP) for validation of plant source identity from NMPB and QCI",
      "ISO 9001, 22000 for Quality and HACCP – TUV South Asia",
      "GMP Certified, Kosher Ceritifed",
    ],
  },
  {
    src: process.env.PUBLIC_URL + "/images/Home/AboutOrgavitaz/GreenChemistry.png",
    name: "Green Chemistry",
    description:
      "Our green chemistry has the following critical aspects;",
    points: [
      "The process that eliminates the handling of hazardous chemicals and solvents.",
      "Range of Green solvents replaces traditional solvents, while adding to the bio-enhancement.",
      "Use of safe biological agents (ecologically native) to valorize the vitamer forms.",
      "Integrate agriculture technology to unburden isolation and synthesis at the process-level for actives consistency.",
      "Innovation in process technology like pressurized, sonicated, super-critical methods for safe standardization.",
    ],
  },
  {
    src: process.env.PUBLIC_URL + "/images/Home/AboutOrgavitaz/ComprehensiveRange1.png",
    name: "Comprehensive Range",
    description:
      "",
    points: [
      "13 vitamins and 7 minerals – comprehensive coverage. ",
      "Bio-vitamers enhance the range multi-fold.",
      "Bio-enhancers offer a multiplier effect.",
      "100+ Incidental Phytoconstituents identified for synergy.",
      "Portfolio covers deficiencies, disease conditions, lifestyle stages and regenesis health.",
      "Range integrates GRAS/EFSA, functionals, clinical ingredients and branded ingredients.",
      "Creates diverse options to effectively formulate functional supplements.",
      
    ],
  },
];

export default function OrgavitazFeatures() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [autoScroll, setAutoScroll] = useState(true);
  const CAROUSEL_INTERVAL = 10000; // 10 seconds

  // Simplified CSS for smooth vertical slide transition without collapsing the parent container
  const animationCss = `
    .slide-enter {
      opacity: 0;
      transform: translateY(20px);
    }
    .slide-enter-active {
      opacity: 1;
      transform: translateY(0);
      transition: opacity 300ms, transform 300ms;
    }
    /* Removed position: absolute; from exit to prevent height collapse */
    .slide-exit {
      opacity: 1;
      transform: translateY(0);
    }
    .slide-exit-active {
      opacity: 0;
      transform: translateY(-20px);
      transition: opacity 300ms, transform 300ms;
    }
  `;

  // Ref for the image wrapper (left side)
  const leftRef = useRef(null); 
  // State for text panel height is unnecessary with the fixed structure
  const [textPanelHeight, setTextPanelHeight] = useState('auto'); 

  // Effect for auto-scrolling the features
  useEffect(() => {
    if (!autoScroll) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) =>
        prev === aboutFeatures.length - 1 ? 0 : prev + 1
      );
    }, CAROUSEL_INTERVAL);

    // Cleanup function
    return () => clearInterval(interval);
  }, [autoScroll]);

  // Handler for user clicking a feature title
  const handleTitleClick = (index) => {
    setActiveIndex(index);
    // User interaction stops auto-scroll
    setAutoScroll(false); 
  };

  const activeContent = aboutFeatures[activeIndex];
  
  return (
    <section className="py-4 position-relative overflow-hidden bg-light">
      {/* Inject animation CSS */}
      <style dangerouslySetInnerHTML={{ __html: animationCss }} />
      <div className="container">
        {/* --- Top Title --- */}
        <div className="row mb-3">
          <div className="col-12">
            <h2 className="fw-bolder mb-3 text-center" style={{ color: brandStyles.linkHover }}>
              Features
            </h2>
          </div>
        </div>
        {/* --- Title Buttons Bar (Navigation) --- */}
        <div className="row mb-4">
          <div className="col-12 d-flex flex-wrap gap-3 border-bottom pb-2">
            {aboutFeatures.map((feature, index) => (
              <div
                key={index}
                onClick={() => handleTitleClick(index)}
                className="position-relative cursor-pointer"
                style={{
                  color: activeIndex === index ? brandStyles.linkHover : brandStyles.deepBlue,
                  fontWeight: activeIndex === index ? 600 : 500,
                  transition: "color 0.3s ease",
                }}
              >
                {feature.name}
                {/* Active underline */}
                {activeIndex === index && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "-4px",
                      left: 0,
                      width: "100%",
                      height: "2px",
                      backgroundColor: brandStyles.linkHover,
                      borderRadius: "2px",
                      transition: "all 0.3s ease",
                    }}
                  ></span>
                )}
              </div>
            ))}
          </div>
        </div>
        {/* --- Bottom Section (Image + Text) --- */}
        <div className="row align-items-start">
          {/* Left Side - Auto Sliding Images */}
          <div className="col-md-6 d-flex flex-column" ref={leftRef}>
            <div className="position-relative rounded shadow-lg overflow-hidden flex-grow-1" style={{ minHeight: "400px" }}>
              {aboutFeatures.map((feature, index) => (
                <img
                  key={index}
                  src={feature.src}
                  alt={feature.name}
                  // Opacity change drives the image fade transition
                  className={`w-100 h-100 position-absolute top-0 start-0 rounded ${
                    index === activeIndex ? "opacity-100" : "opacity-0"
                  }`}
                  style={{
                    objectFit: "cover",
                    transition: "opacity 0.8s ease-in-out",
                  }}
                />
              ))}
            </div>
          </div>
          {/* Right Side - Auto Sliding Text */}
          <div className="col-md-6 mt-4 mt-md-0">
            <SwitchTransition mode="out-in">
              {/* Added key={activeIndex} to CSSTransition */}
              <CSSTransition key={activeIndex} timeout={600} classNames="slide">
                {/* Removed position-absolute on the inner div to prevent height collapse */}
                <div className="w-100"> 
                  <h4 className="fw-bold mb-3" style={{ color: brandStyles.linkHover }}>
                    {activeContent.name}
                  </h4>
                  <p className="mb-3" style={{ fontSize: "0.9rem" }}>
                    {activeContent.description}
                  </p>

                  <ul className="list-group list-group-flush" style={{ fontSize: "0.9rem" }}>
                    {activeContent.points.map((point, idx) => (
                      <li
                        key={idx}
                        className="list-group-item bg-transparent border-0 d-flex align-items-start"
                      >
                        <i className="bi bi-check-circle-fill me-2 mt-1" style={{color: brandStyles.deepBlue}}></i>
                        <span className="text-dark">{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </CSSTransition>
            </SwitchTransition>
          </div>
        </div>
      </div>
    </section>
  );
}